import React from 'react';
import { Button, Card, CardContent, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const NotFoundDisplay = ({ imageUrl, imageAlt }) => {
    // Get the previous route from location state or fallback to the home route
    const location = useLocation();
    const navigate = useNavigate();

    const previousRoute = location.state?.from || '/'; // Default to home if no state exists

    const handleRedirect = () => {
        navigate(previousRoute);
    };

    return (
        <Card sx={{ maxWidth: 345, margin: 'auto', padding: 2 }}>
            <CardContent>
                {/* Image */}
                <img src={imageUrl} alt={imageAlt} style={{ width: '100%', height: 'auto' }} />

                {/* Title or message */}
                <Typography variant="h5" component="div" sx={{ marginTop: 2 }}>
                    Oops! 404 Halaman yang kamu cari tidak ada.
                </Typography>

                {/* Redirect Button */}
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ marginTop: 2 }}
                    onClick={handleRedirect}
                >
                    Kembali
                </Button>
            </CardContent>
        </Card>
    );
};

export default NotFoundDisplay;
